import { render } from "./view_customers.html?vue&type=template&id=e5636466&external"
import script from "./view_customers.js?vue&type=script&lang=js&external"
export * from "./view_customers.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__